module.exports = __webpack_public_path__ + "static/media/ndmi.6e00bd4b.png";